import "../App.css";
import React, { useState, useEffect, useContext } from "react";
import { useParams, useHistory, useLocation } from 'react-router-dom';
import InfiniteScroll from "react-infinite-scroll-component";
//import PageTitle from '../Components/PageTitle';
import CartPopup from '../Components/CartPopup';
import WishlistPopup from '../Components/WishlistPopup';
import Item from '../Components/Item/Item';// scroll infinito
import FilterSection from '../Components/Filter/FilterSection';
import { useInfiniteQuery } from 'react-query';

import AuthContext from "../store/auth-context";

function ProductList(props) {
  const authCtx = useContext(AuthContext);

//  const catParName = "lin";
  const catParName = "cat";
  const catalogPath = "/"+props.cfg.catalogSlug;
  const params = useParams();
  const location = useLocation();
  const history = useHistory();
  const [Filters, setFilters] = useState(props.filtersList);
  const [ActiveFilters, setActiveFilters] = useState(() => {
      const initialState = initActiveFilters();
      return initialState;
    }); // {chkname: {id, value, param}}
  const [IsLoading, setIsLoading] = useState(false);
  const [netError, setNetError] = useState(null);
  const [ScrollToTop, setScrollToTop] = useState(false);
  const [AddToCart, setAddToCart] = useState(false);
  const [ToggleWishlist, setToggleWishlist] = useState(false);  // per far apparire il dialog in caso l'utente sia non loggato
  const [DesktopMode, setDesktopMode] = useState(window.matchMedia(props.cfg.mediaClause).matches? false : true);
  const [ShowFilters, setShowFilters] = useState(false);
  const nPageSize = 12;
/*
  useEffect(() => {
    //console.log("SCROLL UNO");
    window.scrollTo(0, 0);
  }, []);
*/ 
  const {
    status,
    data,
    error,
    isFetching,
    isFetchingNextPage,
    isFetchingPreviousPage,
    fetchNextPage,
    //fetchPreviousPage,
    hasNextPage,
    //hasPreviousPage,
  } = useInfiniteQuery(
//    ["products", location.search],
    ["products", ActiveFilters, props.token],
    async ({ pageParam = 0 }) => {
      let n = pageParam * nPageSize;
      if (props.cfg.debug === true) 
        console.log("FETCHING PRODUCTS (" + pageParam + "): " + n + "-" + (n+nPageSize));
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + props.token.access_token);
      myHeaders.append("Accept", "application/json");

      var formdata = new FormData();
      formdata.append("start", n.toString());
      formdata.append("quanti", nPageSize.toString());
      formdata.append("order_by", "[1]");
      let filterParams = composeFiltersWSParams();
      Object.entries(filterParams).forEach(([k, el]) => {
        formdata.append(k.toString(), JSON.stringify(el));
        if (props.cfg.debug === true) 
          console.log("append: " + k.toString() + ", "+JSON.stringify(el));
      });
      
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      const response = await fetch(
        "https://ws.mediatoys.it/product/ProductAll",
        requestOptions
      );
      //console.log(response);
      if (!response.ok) {
        if (response.status === 401) {
          // check error message???
          console.log("TOKEN UPDATE!");
          props.tokenUpdate();
        }
        throw new Error("Network error " + response.status);
      }
      const respData = await response.json();
      if (props.cfg.debug === true)  {
        console.log(respData);
        //console.log(filterParams);
      }
      
      if (pageParam === 0) 
        setFilters(props.filtersMap(respData.filtri));
      if ((respData.prodotti) && (respData.prodotti.products)) {
        const pg = {
          data: null,
          current_page: pageParam,
        };
        if (props.map !== null) {
          const transformedData = respData.prodotti.products.map((el) => {
            return props.map(el);
          });
          pg.data = transformedData;
        } else {
          pg.data = respData.prodotti.products;
        }
        return pg;
      } else {
        const emptypg = {
          data: [],
          current_page: pageParam,
        };
        return emptypg;
      }
    },
    {
      getNextPageParam: (page) =>
        page.data.length < nPageSize ? undefined : page.current_page + 1,
        //enabled: !!ActiveFilters && !!Filters,
    }
  );

  function composeFiltersWSParams() {
    let pars = {};

    //console.log("composeFilterWSParams() IN");
    //console.log(Filters);
    //console.log(ActiveFilters);
    Object.entries(ActiveFilters).forEach(([key, value]) => {
      //console.log(`${key}: ${value}`)
      if (value.val === true) {
        if (value.param.length === 0) {
          // special case
          console.log("EMPTY PARAM");
          console.log(value);
        } else {
          if (pars[value.param]) 
            pars[value.param].push(value.id);
          else 
            pars[value.param] = [value.id];
        }
      }
    });
    //console.log("WS Filter Params")
    //console.log(pars);
    return pars;
  }


//  console.log("params");
//  console.log(location.search);

  function initActiveFilters() {  
    if (!Filters) 
      return;
    let actFilters = {};
    
    // parse search string parameters for starting active filter values
    // multiple values are joined by "."
    if (location.search.length > 1) {
      //console.log("initActiveFilters() IN: "+location.search);
      //console.log(Filters);
      let s = location.search.substr(1, location.search.length - 1);
      let arr = s.split("&");
      arr.forEach((par) => {
        let kv = par.split("=");
        if (kv.length > 1 && kv[1].length > 0) {
          // ci sono parametri
          let vals = kv[1].split(".");
          vals.forEach((v) => {
            let filtername = kv[0] + "_" + v;
            //if (Filters && Filters[kv[0]]) {
            if (Filters && Filters.hasOwnProperty(kv[0]) && Filters[kv[0]].values.hasOwnProperty(v)) {
              // solo se il filtro è valido
              //console.log(v + " - " + filtername);
              actFilters[filtername] = {
                id: v,
                val: true,
                param: Filters[kv[0]].param,
                //name: Filters[kv[0]].values[v].nome,
              };
            } 
          });
        }
      });
    }    
    if (params.categoryId > 0) {
      let filtername = catParName + "_" + params.categoryId;
      actFilters[filtername] = {id: params.categoryId, val: true, param: "list_id_category2"};
    }
    //console.log("initActiveFilters() -  category " + params.categoryId);
    //console.log(actFilters);
    return actFilters;
  }

  //console.log(params);
  //console.log(ActiveFilters);
  useEffect(() => {
    // impostiamo i filtri attivi in base al formato dell'url
    //console.log("Changed params");
    //console.log(Filters);
    //console.log(ActiveFilters);
    //console.log(params);
    //console.log(location.search);
    if (!Filters) {
      //if (InitFilters.data)
      //  props.filtersMap(InitFilters.data);
      return;
    }
    let newState = initActiveFilters();
    if ((params.categoryId > 0) && (location.search.length === 0)) {
      // aggiungiamo il filtro di categoria quando da menu si chiama una pagina di categoria/linea
      // queste chiamate dalla barra di menu hanno search query vuote
      let filtername = catParName + "_" + params.categoryId;
      newState[filtername] = {id: params.categoryId, val: true, param: "list_id_category2"};
    } 
    setActiveFilters(newState);
  }, [params, Filters]);

  function addToCartHandler(productId, qty=1) {
    let params = [
      {name: "session", value: props.sessionKey},
      {name: "id_utente", value: props.userData? props.userData.id_e_user.toString() : "0"},
      {name: "id_e_products", value: productId.toString()},
      {name: "id_e_products_models", value: "0"},
      {name: "quantita_carrello", value: qty.toString()}
    ];
    props.wsCall("https://ws.mediatoys.it/carrello/add", IsLoading, setIsLoading, netError, setNetError, params, (respData) => {
      props.cartUpd(respData.data);
      setAddToCart(true);
    });    
  }

  async function toggleWishlistHandler(productId, flag) {
    if (props.userData && props.userData.id_e_user.length > 0) {
        //console.log("CLICCATO PREFERITI!");
        let params = [
          {name: "id_e_user", value: props.userData? props.userData.id_e_user.toString() : "0"},
          {name: "id_e_products", value: productId.toString()},
        ];
        props.wsCall("https://ws.mediatoys.it/cliente/add_del_prodotto_preferiti", IsLoading, setIsLoading, netError, setNetError, params, (respData) => {
          //props.cartUpd(respData.data);
          //setAddToCart(true);
          props.setWishlist(respData);
          if (props.cfg.debug === true) 
            console.log(respData);
        })

      } else {
        setToggleWishlist(true);  
      }
  }

  function composeFiltersUrlParams(filters, skipFilterName) {
    let pars = {};
    Object.entries(filters).forEach(([key, value]) => {
      //console.log(`${key}: ${value}`)
      if (value.val === true) {
        if (skipFilterName === "" || skipFilterName !== key) {
          let name = key.substring(0, 3).toLowerCase();
          if (pars[name]) 
            pars[name] += "." + value.id.toString();
          else 
            pars[name] = value.id.toString();
        }
      }
    });

    let strParams = "";
    if (Object.keys(pars).length > 0) {
      Object.entries(pars).forEach(([key, value]) => {
        strParams += "&" + key + "=" + value;
      });
    }
    //console.log(strParams);
    return strParams;
  }

  function composeFiltersUrlQuery(filters, filterName, filterValue, add) {
    let pars = {};
    //console.log("composeFiltersUrlQuery - "+filterName);
    //console.log(filters);
    Object.entries(filters).forEach(([key, value]) => {
      if (value.val === true) {
        if (filterName !== key) {
          // rimozione: considera solo i filtri diversi da filtername
          let name = key.substring(0, 3).toLowerCase();
          //if (params.categoryId === 0 || (name !== catParName || value.id !== params.categoryId)) {
            // ignoriamo il filtro catalogo della pagina catalogo nella stringa di query
            if (pars[name]) 
              pars[name] += "." + value.id.toString();
            else 
              pars[name] = value.id.toString();
          //}
        } 
      } 
    });
    if (add === true) {
      // aggiungi il nuovo filtro attivo
      let name = filterName.substring(0, 3).toLowerCase();
      if (pars[name]) 
        pars[name] += "." + filterValue.toString();
      else 
        pars[name] = filterValue.toString();
    }
 
    let strParams = "";
    if (Object.keys(pars).length > 0) {
      Object.entries(pars).forEach(([key, value]) => {
        strParams += "&" + key + "=" + value;
      });
    }
    //console.log("query string = "+strParams);
    return strParams;
  }

  const activeFilterChangeHandler = (filterName, obj) => {
    //setActiveFilters({ ...ActiveFilters, [filterName]: obj });
    //console.log("ChangeHandler(): filterName = "+filterName);
    //console.log(obj);
    // aggiungi o rimuovi il filtro ai filtri dell'url
    let urlParams = composeFiltersUrlQuery(ActiveFilters, filterName, obj.id, obj.val);
    let urlPath = location.pathname;
    if (params.categoryId > 0) {
      let catfilter = catParName + "_" + params.categoryId;
      if (catfilter === filterName) {
        if (obj.val === false)
          // deselezione del filtro della categoria => url generico
          urlPath = catalogPath;
      } else {
        // controlla se viene attivato un secondo filtro di categoria, 
        // nel qual caso si passa all'url generico
        if ((catParName === filterName.substring(0, 3).toLowerCase()) && (obj.val === true))
          urlPath = catalogPath;
      }
    }

    if (urlParams.length > 0)
      urlPath +="?"+urlParams;
    //console.log("New path = " + urlPath);
    history.push(urlPath);
  };

  function closeCartDialog() {
    setAddToCart(false);
  }

  function closeWishlistDialog() {
    setToggleWishlist(false);
  }

  function manageItemList() {
    if (!data) {
      if (isFetching)
        return null;
      else 
        return <p>No result found</p>;
    }

    if (data.pages.length === 1 && data.pages[0].data.length === 0) {
      if (isFetching)
        return null;
      else 
        return <p>No result found</p>;
    }
    //console.log(data.pages);
    return data.pages.map((page, i) => (
      <React.Fragment key={"pg_"+i}>
        {page.data.map((item) => (
          <Item
            key={"it_"+item.id_e_products}
            item={item}
            urlImg={props.cfg.urlItemImg}
            click={addToCartHandler}
            toggle={toggleWishlistHandler}
            navClick={itemClickHandler}
            wishlist={props.wishlist}
            convert={props.cfg.convert}
            catalogSlug={props.cfg.catalogSlug}        
            />
        ))}
      </React.Fragment>
    )); 
    
  }

  function itemClickHandler(ev) {
    //console.log("Clicked");
    let curLoc = history.location;
    curLoc.state = { itemScrollTop: document.documentElement.scrollTop };
    history.replace(curLoc);
    //console.log("document.scrollTop = " + document.documentElement.scrollTop);
  }  
  
  useEffect(() => {
    //console.log("Scroll Restoration manager");
    if (history.location.state && history.location.state.itemScrollTop >= 0) {
      //console.log("Scroll Restoration to " + history.location.state.itemScrollTop);
      window.scrollTo(0, history.location.state.itemScrollTop);
      let curLoc = history.location;
      curLoc.state = { itemScrollTop: -1 };
      history.replace(curLoc);
    } else {
        if  ((!history.location.state) || (history.location.state && history.location.state.itemScrollTop !== -1)) {
          //console.log("SCROLL DUE");
          window.scrollTo(0, 0);
        }
    }
    //console.log(history.location);
  //}, [location.pathname]);
  }, [ActiveFilters]);  // perfetto per i filtri, ma annulla lo scroll restoration perchè chiamato successivamente a meno che non si usi la if sopra
  
  /*
   useEffect(() => {
    //console.log("Scroll Restoration manager");
    if (history.location.state && history.location.state.itemScrollTop >= 0) {
      console.log("Scroll Restoration to " + history.location.state.itemScrollTop);
      window.scrollTo(0, history.location.state.itemScrollTop);
      let curLoc = history.location;
      curLoc.state = { itemScrollTop: -1 };
      history.replace(curLoc);
    }
    //console.log(history.location);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  */

  // rileva il passaggio in modalità desktop/mobile (e viceversa), causando il
  // rendering della slideshow in modalità differente
  useEffect(() => {
    const onResize = () => {
      let mode = window.matchMedia(props.cfg.mediaClause).matches? false : true;
      //console.log("DesktopMode = "+mode)
      if (mode !== DesktopMode)
        setDesktopMode(mode);
    }

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("scroll", onResize);
  }, [DesktopMode, props.cfg.mediaClause]);


  function getActiveFiltersArray(prefix) {
    //console.log("prefix2 = "+prefix)
    //console.log(ActiveFilters);
    let res = [];
    if (!ActiveFilters)
      return res;
    Object.entries(ActiveFilters).forEach(([key, value]) => {
      //console.log(`${key}: ${value}`)
      if (value.val === true) {
        let pref = key.substring(0, 3).toLowerCase();
        if (pref === prefix) {
          res.push(value.id);
        }
      }
    });
    //console.log("active filters string = "+res)
    return res;
  } 

  function manageFilters(filters) {
    if (filters) {
      let arr = [];
      //let karr = [];
      Object.entries(filters).forEach(([k, el]) => {
        arr.push(el);
        //karr.push(k);
      });

      //console.log("manageFilters() arr")
      //console.log(arr);
      return arr.map((fil, k) => (
        <FilterSection
          key={"fil"+k}
          filters={fil.values}
          prefix={fil.prefix}
          //label={karr[k]}
          label={fil.label}
          param={fil.param}
          //init={Items.length <= nPageSize? true : false}
          activeValues={getActiveFiltersArray(fil.prefix)}
          catId={fil.prefix === catParName? (params.categoryId > 0? params.categoryId : 0) : 0}
          changeHandler={activeFilterChangeHandler}
          initMode={k === 0? 2 : 1}
        />
      ));
    } else return null;
  }

  function manageMobileFilterButton() {
    return (
      <div className="bordo_filtri">
        <div
          className="contenuto_filtri"
          onClick={() => setShowFilters(!ShowFilters)}
        >
          <div className="icona_filtri">
            <img
              src="/images/filtri_on.svg"
              alt="Apri i filtri"
              title="Apri i filtri"
            />
          </div>
          <p>{ShowFilters === true ? "Chiudi i " : "Apri i "} Filtri</p>
        </div>
        <div className="clear"></div>
      </div>
    );
  }

  function showError(text) {
    //setNetError("");
    return <p>{text}</p>;
  }
  function showSpinner() {
    //console.log("spinner SHOW");
    return (
      <div className="spinner" >
        <img src="/images/waiting.gif" alt="loading..." />
      </div>
    );
  }
  function showToTop() {
     return (
      <div
        className="toTop"
        onClick={(e) => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
      >
        <img src="/images/page_up_on.svg" alt="inizio pagina" />
      </div>
    );
  }
  function onScrollHandler() {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300){
      setScrollToTop(true)
    } 
    else {
      setScrollToTop(false)
    }    
  }

  function countItems() {
    if (!data || !data.pages)
      return 0;
    if (data.pages.length === 0)
      return 0;
    //console.log(data);
    let n = data.pages.length;
    let num = (n-1) * nPageSize + data.pages[n-1].data.length;
    //console.log(num);
    return num;
//    return data.pages[data.pages.length-1].length;
  }

  function createTitleString() {
    let txt = "";

    if (ActiveFilters) {
      Object.entries(ActiveFilters).forEach(([k, el]) => {
        if (el.val === true && el.param === "list_id_category2") {
         if (txt.length > 0)
            txt += ", ";
          //txt += el.name;
          txt += props.filtersList.cat.values[el.id].nome;
        }
      });
    }
    if (txt.length === 0) 
      txt = props.cfg.catalogText;
    else 
      txt = props.cfg.catalogText+": " + txt;
    return txt;
  }

  var titleStyle = {
    minHeight: 0,
  };

  //console.log("DesktopMode = "+DesktopMode);
  //console.log("ShowFilters = "+ShowFilters);
  //console.log(ActiveFilters);
  return (
    <div>
      {AddToCart === true ? (
        <CartPopup
          titletext="Congratulazioni!"
          text="Articolo aggiunto al carrello"
          closeHandler={closeCartDialog}
        />
      ) : null}
      {ToggleWishlist === true ? (
        <WishlistPopup
          titletext=""
          text=""
          closeHandler={closeWishlistDialog}
        />
      ) : null}
      <div className="contenitore_01" style={titleStyle}>
        <h1 className="titolo_pagina">{createTitleString()}</h1>

        {status === "loading" ? showSpinner() : null}
        {DesktopMode === false ? (
          <div className="filtri_mobile">{manageMobileFilterButton()}</div>
        ) : null}
        {DesktopMode === true || ShowFilters === true ? (
          <div className="barra-filtri">{manageFilters(Filters)}</div>
        ) : null}

        {status === "error" ? showError(error.message) : null}
        <InfiniteScroll
          dataLength={countItems()}
          next={fetchNextPage}
          hasMore={hasNextPage}
          onScroll={onScrollHandler}
          //scrollThreshold={0.9}
        >
          <div className="contenitore_articoli con-barra" id="results">
            {manageItemList()}
          </div>
        </InfiniteScroll>
        {ScrollToTop === true ? showToTop() : null}
      </div>
    </div>
  );
}

export default ProductList;